
import { defineMessages } from 'react-intl';

export default defineMessages({
    activities: {
        id: 'app.components.classCourses.activities',
        defaultMessage: 'Activities'
    },
    newCourses: {
        id: 'app.components.classCourses.newCourses',
        defaultMessage: 'New Courses'
    },
    skillQuests: {
        id: 'app.components.classCourses.skillQuests',
        defaultMessage: 'Skill Quests'
    },
    noCourseAssigned: {
        id: 'app.components.classCourses.noCourseAssigned',
        defaultMessage: 'No course assigned'
    },
    multipleCourses: {
        id: 'app.components.classCourses.multipleCourses',
        defaultMessage: 'Multiple courses'
    },
    optedOut: {
        id: 'app.components.classCourses.optedOut',
        defaultMessage: 'Opted out'
    },
    noVoluntaryCourseSet: {
        id: 'app.components.classCourses.noVoluntaryCourseSet',
        defaultMessage: 'No voluntary course set'
    },
    noCoursesFound: {
        id: 'app.components.classCourses.noCoursesFound',
        defaultMessage: 'No course found'
    }
});



// WEBPACK FOOTER //
// ./app/components/class-courses/messages.js